/**
 * Creates a type guard function for a union of string literals.
 *
 * @example
 * const VALID_STATUSES = ['REQUESTED', 'ACTIVE', 'ENDED'] as const
 * type TStatus = (typeof VALID_STATUSES)[number]
 * const isStatus = createEnumGuard(VALID_STATUSES)
 * // isStatus('ACTIVE') => true, narrows to TStatus
 */
export function createEnumGuard<T extends string>(validValues: readonly T[]): (value: string) => value is T {
  const set = new Set<string>(validValues)
  return (value: string): value is T => set.has(value)
}

/** Narrows `unknown` to a plain object (`Record<string, unknown>`). */
export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null
}
